import placeholder from "../assets/placeholder.png"

export default placeholder